import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  upcomingButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row'
    }
  },
  upcomingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(4),
      alignItems: 'flex-start',
      flexDirection: 'row'
    }
  },
  upcomingMainContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '&.hasEvents': {
      gap: theme.spacing(4)
    }
  },
  upcomingHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(10)
  },
  upcomingTitle: {
    fontWeight: 700
  },
  button: {
    borderRadius: 20,
    width: 280,
    height: 40,
    flexShrink: 0,
    boxShadow: 'none',
    marginTop: theme.spacing(4),

    '& span': {
      color: theme.palette.primary.main,
      fontWeight: 700,
      fontSize: '1.125rem'
    },
    [theme.breakpoints.up('md')]: {
      marginTop: -theme.spacing()
    }
  }
}))
